// @flow
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';

type Props = {
  options: any,
};

export default ({ options }: Props) => (
  <HighchartsReact highcharts={Highcharts} options={options} />
);
